import Vue from "vue";
import Router from "vue-router";
import LandingView from "./views/LandingView.vue";
import NProgress from "nprogress";

import QuestionClassView from "@/views/QuestionClassView";
import GroupView from "@/views/GroupView";
import SubjectView from "@/views/SubjectView";
import LoginView from "./views/LoginView.vue";
import LogoutView from "./views/LogoutView.vue";
import ProfileView from "./views/ProfileView.vue";
import QuestionView from "./views/QuestionView.vue";
import DictionaryView from "./views/DictionaryView.vue";
import QuestionPoolView from "./views/QuestionPoolView.vue";
import NotYetImplementedView from "./views/NotYetImplementedView.vue";
import TestSelectionView from "./views/TestSelectionView.vue";
import TestView from "./views/TestView.vue";
import AppExplainedView from "./views/AppExplainedView.vue";
import ChangelogView from "./views/ChangelogView.vue";
import ImprintView from "./views/ImprintView.vue";

import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "landing",
      component: LandingView,
      meta: {
        pageType: "home",
      },
    },
    {
      path: "/changelog",
      name: "changelog",
      component: ChangelogView,
      meta: {
        hideProfile: true,
        pageType: "home",
      },
    },
    {
      path: "/grundwissen",
      name: "grundwissen",
      component: QuestionClassView,
      meta: {
        classSlug: "grundwissen",
        pageType: "questions-gw",
      },
    },
    {
      path: "/grundwissen/:slug",
      name: "grundwissen-group",
      component: SubjectView,
      meta: {
        classSlug: "grundwissen",
        pageType: "questions-gw",
      },
    },
    {
      path: "/grundwissen/:group_slug/:subject_slug",
      name: "grundwissen-subject",
      component: SubjectView,
      meta: {
        classSlug: "grundwissen",
        pageType: "questions-gw",
      },
    },
    {
      path: "/(b-fuehrerschein|b-fragen)",
      name: "b-fuehrerschein",
      component: QuestionClassView,
      meta: {
        classSlug: "b-fragen",
        pageType: "questions-b",
      },
    },
    {
      path: "/(b-fuehrerschein|b-fragen)/:slug",
      name: "b-subject",
      component: SubjectView,
      meta: {
        classSlug: "b-fragen",
        pageType: "questions-b",
      },
    },
    //{
    //path: "/(b-fuehrerschein|b-fragen)/:group_slug/:subject_slug",
    //name: "b-group-subject",
    //component: SubjectView,
    //meta: {
    //classSlug: 'b-fragen',
    //pageType: 'questions-b'
    //}
    //},
    {
      path: "/frage/:question_id?",
      name: "question",
      component: QuestionView,
      meta: {
        pageType: "question",
      },
    },
    {
      path: "/schwere-fragen",
      name: "hard-questions",
      component: QuestionPoolView,
      meta: {
        pageType: "hard-questions",
        follow_up_questions: true,
      },
    },
    {
      path: "/5-punkte-fragen",
      name: "5-point-questions",
      component: QuestionPoolView,
      meta: {
        pageType: "5-point-questions",
        poolUrl: "/f-ll/questions/hard",
        follow_up_questions: true,
      },
    },
    {
      path: "/fragen",
      name: "questions",
      component: QuestionPoolView,
      meta: {
        pageType: "questions",
        poolUrl: "/f-ll/questions",
        follow_up_questions: true,
      },
    },
    {
      path: "/falsch-beantwortete",
      name: "wrong-questions",
      component: QuestionPoolView,
      meta: {
        pageType: "wrong-questions",
        poolUrl: "/f-ll/questions/wrong",
      },
    },
    {
      path: "/pruefung",
      name: "test-selection",
      component: TestSelectionView,
      meta: {
        pageType: "test-selection",
      },
    },
    {
      path: "/pruefung/:type",
      name: "take-test",
      component: TestView,
      meta: {
        pageType: "test",
      },
    },
    {
      path: "/begriffe",
      name: "dictionary",
      component: DictionaryView,
      meta: {
        pageType: "dictionary",
      },
    },
    {
      path: "/hilfe",
      name: "help",
      component: AppExplainedView,
      meta: {
        pageType: "help",
      },
    },
    {
      path: "/login",
      name: "login",
      component: LoginView,
    },
    {
      path: "/logout",
      name: "logout",
      component: LogoutView,
    },
    {
      path: "/profil",
      name: "profil",
      component: ProfileView,
      meta: {
        hideProfile: true,
      },
    },
    {
      path: "/impressum",
      name: "imprint",
      component: ImprintView,
      meta: {
        hideProfile: true,
      },
    },
    {
      path: "*",
      component: NotYetImplementedView,
    },
  ],
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.beforeEach((to, from, next) => {
  if (
    to.name &&
    to.name != "login" &&
    to.name != "logout" &&
    to.name != "landing" &&
    to.name != "imprint" &&
    to.name != "changelog"
  ) {
    if (!store.getters.user) {
      next("/login");
    }
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

//router.beforeEach((to, from, next) => {
//console.log(to, from);
//next();
//});

export default router;
